        import Validation from '../../../common/assets/js/validation';

export default new class ProductOffers {
    constructor() {
        this.totalPrice = '.js-totalPrice';
        this.pricePerDay = '.js-pricePerDay';
        this.amount = '._js-prod-count';
        this.period = '.js-period';
        this.defaultValue = 1;
        this.item = '.product-offers__owner';
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(document)
            .on('change', this.amount, (e) => {
                let $field = $(e.target),
                    $item = $field.closest(this.item);

                this.calculateProductPrice($item);
            });
    }

    calculateProductPrice($item) {
        let pricePerDay = $item.find(this.pricePerDay).text().replace(',', '.'),
            amount = $item.find(this.amount).val(),
            period = $('.oc-filter-shopaholic._calendar-data ._period input').val(),
            totalPrice;

        if ($.isNumeric(pricePerDay) && $.isNumeric(amount)) {
            totalPrice = ((pricePerDay  * amount * period).toFixed(2)).replace('.', ',');
            $item.find(this.totalPrice).text(totalPrice);
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/product-offers/product-offers.js